import { CascadiaColor } from "@certn/cascadia-tokens";
import { getMatchingConditionDefinition } from "../../utils";

export function getTextColor(
  item: any,
  subtitleDefinition: Record<string, any>
) {
  const matchedColor = getMatchingConditionDefinition(
    item,
    subtitleDefinition.textColorConditionDefinitions || []
  )?.value as CascadiaColor | null | undefined;
  return matchedColor || "text-base";
}
